export default __webpack_public_path__ + "static/media/Rasalghul.be8dc10c.png";